// extracted by mini-css-extract-plugin
export default {"spinner":"AuthChecker_spinner__ngFWk"};